// Auto-generated per-query builders for InterfacePort
// DO NOT EDIT - Changes will be overwritten

import { QueryBuilderBase } from '@sourcepilot/framework/query-builder-base';
import { NeoNodeBase } from '@sourcepilot/framework/neo-node-base';
import { RelationshipManager } from '@sourcepilot/framework/relationship-manager';
import { Relationship } from '@sourcepilot/framework/relationship';
import { InterfacePortReadAPI, InterfacePortWriteAPI, InterfacePortReadAPISchema, InterfacePortWriteAPISchema } from '../types/interfaceport';
import { ModelRegistry } from '../../registries/model-registry';
import { AtScope, ConnectionEndA, ConnectionEndB, HasAttribute, HasAttributeValue, HasDerivedValue, HasInterfacePort, Mentions, PartBindsInterfacePort, Satisfies, StandardForInterfacePort } from '../../relationships/relationship';

import { Standard } from './standard';
import { LogicalPart } from './logicalpart';
import { Requirement } from './requirement';
import { SecurityScope } from '../../shared/api/securityscope';
import { Attribute } from './attribute';
import { AttributeValue } from './attributevalue';
import { DerivedValue } from './derivedvalue';
import { Expression } from './expression';
import { Connection } from './connection';





// Builder chain for query: rflp-interface-port-by-id

export interface RflpInterfacePortByIdBuilder_0 {
  get(id: string): RflpInterfacePortByIdBuilder_1;
  filter(conditions: { id: string }): RflpInterfacePortByIdBuilder_1;
}

export interface RflpInterfacePortByIdBuilder_1 {
  all(): Promise<InterfacePort[]>;
  first(): Promise<InterfacePort | null>;
  get(): Promise<InterfacePort[]>;
  execute(): Promise<InterfacePort[]>;
}


// Union of all query entry points
export type InterfacePortQueryBuilder = RflpInterfacePortByIdBuilder_0;

// Available query names for .setQuery()
export type InterfacePortQueryNames = "rflp-interface-port-by-id";

// Type narrowing for .setQuery()
export type InterfacePortBuilderForQuery<Q extends InterfacePortQueryNames> =
  Q extends "rflp-interface-port-by-id" ? RflpInterfacePortByIdBuilder_0
  : never;

// Type for instance setQuery - returns post-filter/post-get builder
export type InterfacePortInstanceQueryResult<Q extends InterfacePortQueryNames> =
  Q extends "rflp-interface-port-by-id" ? RflpInterfacePortByIdBuilder_1
  : never;

// Map path signatures to query names
const QUERY_PATH_MAP: Record<string, string> = {
  '': 'rflp-interface-port-by-id',
};

// Model-specific QueryBuilder implementation
class QueryBuilderImpl extends QueryBuilderBase {
  constructor(
    modelName: string,
    path: string[] = [],
    params: Record<string, any> = {},
    fetchFn?: (path: string, options?: RequestInit) => Promise<any>,
    queryName?: string,
    scopedParams: Record<string, Record<string, any>> = {}
  ) {
    super(modelName, path, params, fetchFn, queryName, scopedParams, QUERY_PATH_MAP, QueryBuilderImpl);
  }

  setQuery<Q extends InterfacePortQueryNames>(queryName: Q): InterfacePortBuilderForQuery<Q> {
    // Create new builder with queryName set to bypass path lookup
    return new QueryBuilderImpl(
      this.modelName,
      this.path,
      this.params,
      this.fetchFn,
      queryName,
      this.scopedParams
    ) as any;
  }
}


export interface InterfacePort extends Partial<InterfacePortReadAPI> {}
export class InterfacePort extends NeoNodeBase<InterfacePortReadAPI, InterfacePortWriteAPI> {
  // Static label for identifying this model type (minification-safe)
  static readonly label = "InterfacePort";
  static readonly readSchema = InterfacePortReadAPISchema;
  static readonly writeSchema = InterfacePortWriteAPISchema;

  // Per-relationship metadata, keyed by property name on this class.
  // See `framework/data/dag-sync/reverse-property.ts` for how the DAG
  // client uses (relClass, direction) to route patches back to the
  // correct property — especially for polymorphic-source rels.
  static readonly relationships: Record<string, {
    target: string;
    cardinality: 'one' | 'many';
    isParent: boolean;
    relClass: string;
    direction: 'in' | 'out';
  }> = {
    attributes: { target: "Attribute", cardinality: "many", isParent: false, relClass: "HasAttribute", direction: "out" },
    attribute_values: { target: "AttributeValue", cardinality: "many", isParent: false, relClass: "HasAttributeValue", direction: "out" },
    derived_values: { target: "DerivedValue", cardinality: "many", isParent: false, relClass: "HasDerivedValue", direction: "out" },
    mentioned_in_expressions: { target: "Expression", cardinality: "many", isParent: false, relClass: "Mentions", direction: "in" },
    connections_as_a: { target: "Connection", cardinality: "many", isParent: false, relClass: "ConnectionEndA", direction: "in" },
    connections_as_b: { target: "Connection", cardinality: "many", isParent: false, relClass: "ConnectionEndB", direction: "in" },
    standard: { target: "Standard", cardinality: "one", isParent: false, relClass: "StandardForInterfacePort", direction: "out" },
    satisfies: { target: "Requirement", cardinality: "many", isParent: false, relClass: "Satisfies", direction: "out" },
    owner: { target: "LogicalPart", cardinality: "one", isParent: true, relClass: "HasInterfacePort", direction: "in" },
    bound_to: { target: "LogicalPart", cardinality: "many", isParent: false, relClass: "PartBindsInterfacePort", direction: "in" },
  };

  protected get modelName(): string {
    return 'InterfacePort';
  }

  // Instance getter for label (used in DAG sync and type identification)
  get _label(): string {
    return InterfacePort.label;
  }


  constructor(data: Partial<InterfacePortWriteAPI> = {}) {
    super(data);
  }

/**
   * Load instance from server data with Zod validation
   * Recursively instantiates nested relationship objects
   *
   * @param data - Node data from API (ReadAPI format)
   * @param loadContext - Optional LoadContext from backend QueryResult for eager-loaded relationships
   * @returns Class instance with nested relationships instantiated
   */
  static load(data: InterfacePortReadAPI, loadContext?: Record<string, any>): InterfacePort {
    // Import relationship loaders
    const { loadOneRelationship, loadManyRelationship } = require('@sourcepilot/framework/load-relationship');

    // Strip relationship fields before validation (they'll be processed separately)
    const { standard, satisfies, owner, bound_to, security_scope, attributes, attribute_values, derived_values, mentioned_in_expressions, connections_as_a, connections_as_b, _label, ...dataToValidate } = data as any;

    // Validate with Zod schema (only non-relationship fields)
    const validated = InterfacePortReadAPISchema.parse(dataToValidate);

    // Re-add relationship fields to validated data for processing
    const dataWithRelationships: any = { ...validated, standard: standard, satisfies: satisfies, owner: owner, bound_to: bound_to, security_scope: security_scope, attributes: attributes, attribute_values: attribute_values, derived_values: derived_values, mentioned_in_expressions: mentioned_in_expressions, connections_as_a: connections_as_a, connections_as_b: connections_as_b };

    // If loadContext provided, use NeoGraphParser to reconstruct relationships
    if (loadContext && validated.id) {
      // Import NeoGraphParser dynamically to avoid circular dependencies
      const { NeoGraphParser } = require('@sourcepilot/framework/neograph-utils');
      const parser = new NeoGraphParser();
      const graphNodes = parser.parse([validated], loadContext);

      if (graphNodes.length > 0) {
        // Convert graph structure back to plain object with relationships
        const withRelationships = parser.toPlainObject(graphNodes[0]);
        // Recursively instantiate via ModelRegistry (without loadContext to avoid infinite loop)
        return InterfacePort.load(withRelationships);
      }
    }

    // Recursively instantiate nested relationships from inline data
    const processed: any = { ...dataWithRelationships };

    // Process relationships: convert to class instances and store with private property names
    loadOneRelationship(processed, 'standard', 'Standard', ModelRegistry);
    loadManyRelationship(processed, 'satisfies', 'Requirement', ModelRegistry);
    loadManyRelationship(processed, 'owner', 'LogicalPart', ModelRegistry);
    loadManyRelationship(processed, 'bound_to', 'LogicalPart', ModelRegistry);
    loadOneRelationship(processed, 'security_scope', 'SecurityScope', ModelRegistry);
    loadManyRelationship(processed, 'attributes', 'Attribute', ModelRegistry);
    loadManyRelationship(processed, 'attribute_values', 'AttributeValue', ModelRegistry);
    loadManyRelationship(processed, 'derived_values', 'DerivedValue', ModelRegistry);
    loadManyRelationship(processed, 'mentioned_in_expressions', 'Expression', ModelRegistry);
    loadManyRelationship(processed, 'connections_as_a', 'Connection', ModelRegistry);
    loadManyRelationship(processed, 'connections_as_b', 'Connection', ModelRegistry);
    // Create instance with processed data (constructor uses Object.assign)
    // Private properties (_*) won't conflict with relationship getters
    const instance = new InterfacePort(processed as any);

    return instance;
  }

  static filter(conditions: Record<string, any>): InterfacePortQueryBuilder {
    return new QueryBuilderImpl('InterfacePort').filter(conditions) as any;
  }

  static all(): InterfacePortQueryBuilder {
    return new QueryBuilderImpl('InterfacePort') as any;
  }

  static async first(): Promise<InterfacePort | null> {
    const results = await new QueryBuilderImpl('InterfacePort').execute();
    return results[0] || null;
  }


  static setQuery<Q extends InterfacePortQueryNames>(queryName: Q): InterfacePortBuilderForQuery<Q> {
    const builder = new QueryBuilderImpl('InterfacePort');
    return builder.setQuery(queryName);
  }

  /**
   * Instance method to create queries pre-filtered by this instance's ID.
   * Enables queries like: thread.setQuery('thread-with-steps').steps.all()
   * Returns the same builder type as static method after applying ID filter.
   */
  setQuery<Q extends InterfacePortQueryNames>(queryName: Q): InterfacePortInstanceQueryResult<Q> {
    if (!this.id) {
      throw new Error('Cannot query an unsaved instance without an ID');
    }
    // Create a query builder and apply the ID
    const builder = InterfacePort.setQuery(queryName) as any;

    // Try .get(id) first (if the query starts with Thread.get())
    // Otherwise use .filter({id}) (if the query starts with Thread.filter(id=...))
    // The return type mapping handles which builder stage is returned
    if (builder.get && typeof builder.get === 'function') {
      return builder.get(this.id);
    } else if (builder.filter && typeof builder.filter === 'function') {
      return builder.filter({ id: this.id });
    }
    return builder;
  }

  /**
   * Delete this instance from the server.
   *
   * @param options - Delete options
   * @param options.cascade - Whether to cascade delete related nodes (default: true for most models)
   * @param options.dryRun - If true, return what would be deleted without actually deleting
   * @returns DeleteResult with deleted IDs and count
   *
   * @example
   * ```typescript
   * const interfaceport = await InterfacePort.get(id).first();
   * await interfaceport.delete();  // Delete with default cascade
   *
   * // Or with options
   * const result = await interfaceport.delete({ cascade: false, dryRun: true });
   * console.log('Would delete:', result.deletedIds);
   * ```
   */
  async delete(options: {
    cascade?: boolean;
    dryRun?: boolean;
  } = {}): Promise<{ deletedIds: string[]; count: number }> {
    return this._deleteInstance(options);
  }

  // Relationship manager for 'standard' - Python ORM style (cached)
  get standard(): RelationshipManager<this, Standard> {
    return this.getOrCreateRelationshipManager('standard', () => {
      return new RelationshipManager(this, 'standard', 'one', StandardForInterfacePort as typeof Relationship);
    });
  }

  // Relationship manager for 'bound_to' - Python ORM style (cached)
  get bound_to(): RelationshipManager<this, LogicalPart> {
    return this.getOrCreateRelationshipManager('bound_to', () => {
      return new RelationshipManager(this, 'bound_to', 'many', PartBindsInterfacePort as typeof Relationship);
    });
  }

  // Relationship manager for 'satisfies' - Python ORM style (cached)
  get satisfies(): RelationshipManager<this, Requirement> {
    return this.getOrCreateRelationshipManager('satisfies', () => {
      return new RelationshipManager(this, 'satisfies', 'many', Satisfies as typeof Relationship);
    });
  }

  // Relationship manager for 'owner' - Python ORM style (cached)
  get owner(): RelationshipManager<this, LogicalPart> {
    return this.getOrCreateRelationshipManager('owner', () => {
      return new RelationshipManager(this, 'owner', 'many', HasInterfacePort as typeof Relationship);
    });
  }

  // Relationship manager for 'security_scope' - Python ORM style (cached)
  get security_scope(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('security_scope', () => {
      return new RelationshipManager(this, 'security_scope', 'one', AtScope as typeof Relationship);
    });
  }

  // Relationship manager for 'attributes' - Python ORM style (cached)
  get attributes(): RelationshipManager<this, Attribute> {
    return this.getOrCreateRelationshipManager('attributes', () => {
      return new RelationshipManager(this, 'attributes', 'many', HasAttribute as typeof Relationship);
    });
  }

  // Relationship manager for 'attribute_values' - Python ORM style (cached)
  get attribute_values(): RelationshipManager<this, AttributeValue> {
    return this.getOrCreateRelationshipManager('attribute_values', () => {
      return new RelationshipManager(this, 'attribute_values', 'many', HasAttributeValue as typeof Relationship);
    });
  }

  // Relationship manager for 'derived_values' - Python ORM style (cached)
  get derived_values(): RelationshipManager<this, DerivedValue> {
    return this.getOrCreateRelationshipManager('derived_values', () => {
      return new RelationshipManager(this, 'derived_values', 'many', HasDerivedValue as typeof Relationship);
    });
  }

  // Relationship manager for 'mentioned_in_expressions' - Python ORM style (cached)
  get mentioned_in_expressions(): RelationshipManager<this, Expression> {
    return this.getOrCreateRelationshipManager('mentioned_in_expressions', () => {
      return new RelationshipManager(this, 'mentioned_in_expressions', 'many', Mentions as typeof Relationship);
    });
  }

  // Relationship manager for 'connections_as_a' - Python ORM style (cached)
  get connections_as_a(): RelationshipManager<this, Connection> {
    return this.getOrCreateRelationshipManager('connections_as_a', () => {
      return new RelationshipManager(this, 'connections_as_a', 'many', ConnectionEndA as typeof Relationship);
    });
  }

  // Relationship manager for 'connections_as_b' - Python ORM style (cached)
  get connections_as_b(): RelationshipManager<this, Connection> {
    return this.getOrCreateRelationshipManager('connections_as_b', () => {
      return new RelationshipManager(this, 'connections_as_b', 'many', ConnectionEndB as typeof Relationship);
    });
  }

}
